import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatDate } from "../lib/api";
import { fmtMoney, fmtNumber, AGING_STYLES, AgingChip, StatusPill } from "../components/ops/opsUtils";

export default function AgingView() {
  const [buckets, setBuckets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { (async () => {
    try {
      const { data } = await api.get("/operations/aging");
      setBuckets(data);
    } finally { setLoading(false); }
  })(); }, []);

  if (loading) return <div className="p-10 text-[#6B7280]" data-testid="aging-loading">Loading aging buckets…</div>;

  return (
    <div className="p-6 md:p-8 max-w-[1500px] mx-auto" data-testid="aging-view">
      <div className="uppercase-label">Operations</div>
      <h1 className="font-display text-3xl font-semibold tracking-tight text-[#0A2540]">Portfolio aging</h1>
      <p className="text-sm text-[#6B7280] mt-1.5 mb-6">Active loans grouped by months outstanding. Older loans surface for follow-up.</p>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        {buckets.map((b) => {
          const cfg = AGING_STYLES[b.bucket] || AGING_STYLES["0_3_months"];
          return (
            <div key={b.bucket} className="bg-white border border-[#E5E7EB] rounded-lg overflow-hidden flex flex-col" data-testid={`aging-bucket-${b.bucket}`}>
              <div className="px-4 py-3 border-b border-[#E5E7EB] flex items-center justify-between" style={{ background: cfg.bg }}>
                <div className="font-medium text-sm" style={{ color: cfg.text }}>{cfg.label}</div>
                <div className="text-xs font-medium tabular-nums" style={{ color: cfg.text }}>{b.loans.length}</div>
              </div>
              <div className="p-3 space-y-2 max-h-[700px] overflow-y-auto">
                {b.loans.length === 0 && <div className="text-xs text-[#9CA3AF] italic py-4 text-center">None</div>}
                {b.loans.map((l, i) => (
                  <Link key={l.loan_id} to={`/admin/loans/${l.loan_id}`} data-testid={`aging-card-${l.loan_id}`}
                        className="block p-3 rounded-md border border-[#E5E7EB] hover:border-[#0066FF] transition-colors">
                    <div className="font-medium text-sm text-[#0A2540] truncate">{l.client_name}</div>
                    <div className="text-[11px] text-[#6B7280] truncate mt-0.5">{l.attorney_email}</div>
                    <div className="flex items-center justify-between mt-2">
                      <div className="text-sm text-[#0A2540] tabular-nums font-medium">{fmtMoney(l.current_payoff)}</div>
                      <StatusPill status={l.current_status} />
                    </div>
                    <div className="text-[11px] text-[#9CA3AF] mt-1">Funded {formatDate(l.funding_date)} · {l.months_outstanding?.toFixed(1)}mo</div>
                  </Link>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
